import { Controller } from "@hotwired/stimulus"

// Manages user selection for merge in management users index.
// Click avatars to select users in order (first = target, rest = sources).
// Uses event delegation so it works after AJAX table replacement.
export default class extends Controller {
  static targets = ["avatar", "mergeButton"]
  static values = {
    mergePreviewUrl: String
  }

  connect() {
    this.selectedIds = []
    this.boundHandleClick = this.handleClick.bind(this)
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    this.boundHandleTableUpdate = this.handleTableUpdate.bind(this)
    this.element.addEventListener("click", this.boundHandleClick)
    this.element.addEventListener("keydown", this.boundHandleKeydown)
    document.addEventListener("users-table-updated", this.boundHandleTableUpdate)
    this.updateUI()
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundHandleClick)
    this.element.removeEventListener("keydown", this.boundHandleKeydown)
    document.removeEventListener("users-table-updated", this.boundHandleTableUpdate)
  }

  handleTableUpdate() {
    this.updateUI()
  }

  handleKeydown(event) {
    const avatar = event.target.closest("[data-user-merge-select-target='avatar']")
    if (!avatar) return
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      this.toggleUser(avatar)
    }
  }

  handleClick(event) {
    const avatar = event.target.closest("[data-user-merge-select-target='avatar']")
    if (!avatar) return

    event.preventDefault()
    this.toggleUser(avatar)
  }

  toggleUser(avatar) {
    const userId = avatar.dataset.userId
    if (!userId) return

    const idx = this.selectedIds.indexOf(userId)
    if (idx >= 0) {
      this.selectedIds.splice(idx, 1)
    } else {
      this.selectedIds.push(userId)
    }
    this.updateUI()
  }

  updateUI() {
    this.updateAvatarStates()
    this.updateMergeButton()
  }

  updateAvatarStates() {
    const avatars = this.element.querySelectorAll("[data-user-merge-select-target='avatar']")
    avatars.forEach((avatar) => {
      const userId = avatar.dataset.userId
      const idx = this.selectedIds.indexOf(userId)
      avatar.classList.toggle("user-merge-selected", idx >= 0)
      avatar.removeAttribute("data-merge-order")
      if (idx >= 0) {
        avatar.setAttribute("data-merge-order", String(idx + 1))
      }
    })
  }

  updateMergeButton() {
    if (!this.hasMergeButtonTarget) return
    const btn = this.mergeButtonTarget

    if (this.selectedIds.length >= 2) {
      btn.classList.remove("uk-hidden")
      btn.href = this.buildMergePreviewUrl()
    } else {
      btn.classList.add("uk-hidden")
    }
  }

  buildMergePreviewUrl() {
    const base = this.mergePreviewUrlValue || "/management/users/merge_preview"
    const params = new URLSearchParams()
    this.selectedIds.forEach((id) => params.append("user_ids[]", id))
    return `${base}?${params.toString()}`
  }
}
